import RestService from './RestService';

export async function getLocation(locationSlug) {
	const res = await RestService.performRestOpNext(`authorizer/kayaking-geo/get-raw`, {
		locationSlug
	});

	console.log(res);
	return res;
}

export async function updateLocation(location) {
	console.log(location);
	const res = await RestService.performRestOpNext(`authorizer/kayaking-geo/update`, location);
	console.log(res);
	return res;
}